<template>
	<div 
		:class="{ 'is-sticky': isSticky }"
		class="categories-tab clearfix"
	>
		<ul 
			v-if="tabs.length"
			class="order-tabs"
		>
			<li 
				v-for="( tab, i ) in tabs"
				:key="tab.name"
				:class="{ 
					'is-active': tab.isActive, 
					'is-disabled': maybeDisableCheckoutButton( tab.name ) 
				}"
				class="order-tab"
			>
				<button 
					@click="handleTabClick( tab.name )"
					:disabled="maybeDisableCheckoutButton( tab.name )"
					class="order-tab__btn"
				>
					<span class="hidden-md-up">{{ 1 + i }} of {{ tabs.length }}: </span>
					<span class="hidden-sm-down">{{ 1 + i }}. </span>
					<span class="order-tab__label">{{ tab.name }}</span>
				</button>
			</li>
		</ul>
	</div>
</template>


<script>
	export default {
		name: 'Tabs',
		props: {
			tabs: {
				type: Array,
				required: true,
			},
			cart_items: { // used to set disable state for checkout button
				type: Array,
				default() {
					return []
				}
			},
		},


		data() {
			return {
				isSticky: 		false,
				stickyDebounce:	null,
				headerHeight: 	null,
				tabsTop: 		null,
			}
		},


		created() {
			const header = document.getElementById('page-header')

			if( null !== header ) {
				this.headerHeight = header.getBoundingClientRect().height
			}

			window.addEventListener( 'resize', this.handleResize )
			window.addEventListener( 'scroll', this.handleScroll )
		},


		mounted() {
			this.tabsTop = this.$el.getBoundingClientRect().top
		},


		destroyed() {
			window.removeEventListener( 'resize', this.handleResize )
			window.removeEventListener( 'scroll', this.handleScroll )
		},


		methods: {
			handleTabClick( tabName ) {

				// @todo — add notice?
				if( 'Checkout' === tabName && !this.cart_items.length ) {
					return
				} else {
					this.$emit( 'tab_click', tabName )
				}
			},


			maybeDisableCheckoutButton( tabName ) {
				return ( 'Checkout' === tabName && !this.cart_items.length )
			},


			handleResize() {
				this.tabsTop = this.$el.getBoundingClientRect().top

				this.applyStickyDebounce()
			},


			handleScroll() {
				this.applyStickyDebounce()
			},


			applyStickyDebounce() {
				const self = this

				if( null !== self.stickyDebounce ) {
					cancelAnimationFrame( self.stickyDebounce )
				}

				self.stickyDebounce = requestAnimationFrame( self.maybeModifyStickyState, 100 )
			},


			maybeModifyStickyState() {
				const self = this,
					header = document.getElementById('page-header')

				let offset = 0

				if( null !== header ) {
					offset = header.getBoundingClientRect().height
				}

				// check for window size (shouldn't be sticky on desktop)
				if( 1024 < window.innerWidth ) {
					self.isSticky = false
				} else {
					self.isSticky = ( self.tabsTop < ( offset + window.scrollY ) )
				}

				// conditionally set sticky placement
				if( self.isSticky ) {
					self.$el.style.setProperty( '--shiftY', `${offset}px` )
				} else {
					self.$el.style.removeProperty( '--shiftY' )
				}
			}
		}
	}
</script>